var _ = require("../../../uam/module.js")(module.exports, {
  namespace: "ua.preview.text",
  title: "Control Preview: Text",
  description: "Read-only preview renderer for plain text-like control values.",
  fields: {
    "value": { title: "Value", type: "*", description: "Value to preview." },
    "emptyText": { title: "Empty Text", type: "string", description: "Fallback text for empty values.", default: "Not provided" }
  }
});

var helper = require("./helpers/control.preview.js");

exports.render = async function(options) {
  var labels = (options && options.optionLabels) || {};
  var value = options.value;
  // A choice control stores a code ("under-1yr"); show the label the person picked.
  if (typeof value === "string" && Object.prototype.hasOwnProperty.call(labels, value)) {
    value = labels[value];
  }
  var text = helper.valueToText(value);
  if (!text) {
    text = options.emptyText || "Not provided";
    return helper.renderDoc({
      n: "span",
      c: "ua-control-preview-empty",
      i: text
    });
  }

  return helper.renderDoc({
    n: "span",
    c: "ua-control-preview-text",
    i: text
  });
};

/* Plain-text twin of render() for non-DOM surfaces (emails, logs, exports):
 * the same readable value, as a string. "" means nothing to show. */
exports.toText = function(options) {
  options = options || {};
  var labels = options.optionLabels || {};
  var value = options.value;
  if (typeof value === "string" && Object.prototype.hasOwnProperty.call(labels, value)) value = labels[value];
  return helper.valueToText(value).trim();
};
